export default {
  env: 'development',
  sentryDsn:
    'https://1b961787945742cca7331ffc1619e670@o933210.ingest.sentry.io/5883998'
}
